import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import { Stack } from '@superdispatch/ui';
import { Button, TextBox } from '@superdispatch/ui-lab';
import { InsuranceCertificateHolderInstruction } from 'shared/modules/carrier-profile/core/InsuranceCertificateHolderInstruction';
import { WebViewLink } from 'shared/routing/WebViewLinks';

interface LoadboardReviewedDialogProps {
  open: boolean;
  onClose: () => void;
}

export function LoadboardReviewedDialog({
  open,
  onClose,
}: LoadboardReviewedDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        Super Dispatch is still waiting for confirmation of your Cargo Insurance
        verification
      </DialogTitle>

      <DialogContent>
        <Stack space="small">
          <InsuranceCertificateHolderInstruction />
          <Typography>
            You can still book loads from this Shipper who have{' '}
            <TextBox variant="body-semibold">approved</TextBox> you to request
            or <TextBox variant="body-semibold">instantly book</TextBox>.
          </Typography>
          <WebViewLink
            target="_blank"
            rel="noreferrer noopener"
            href="https://support.superdispatch.com/hc/articles/35653827823507-Adding-Super-Dispatch-As-A-Certificate-Holder-on-Your-COI"
          >
            Learn More
          </WebViewLink>
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Got it</Button>
      </DialogActions>
    </Dialog>
  );
}
